import { render, staticRenderFns } from "./RouterHome.vue?vue&type=template&id=bade81ec&"
import script from "./RouterHome.vue?vue&type=script&lang=js&"
export * from "./RouterHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports